import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
/**
 * Block used to apply a cross product between 2 vectors
 */
export class RewardSplitVectorBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("vector", RewardGraphConnectionPointTypes.Vector3);
        this.registerOutput("x", RewardGraphConnectionPointTypes.Float);
        this.registerOutput("y", RewardGraphConnectionPointTypes.Float);
        this.registerOutput("z", RewardGraphConnectionPointTypes.Float);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardSplitVectorBlock";
    }

    public get x(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    public get y(): RewardGraphConnectionPoint {
        return this._outputs[1];
    }

    public get z(): RewardGraphConnectionPoint {
        return this._outputs[2];
    }

    public get vector(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    protected override _buildBlock() {
        if (!this.vector.isConnected) {
            this.x._storedFunction = null;
            this.x._storedValue = null;
            this.y._storedFunction = null;
            this.y._storedValue = null;
            this.z._storedFunction = null;
            this.z._storedValue = null;
            return;
        }

        this.x._storedFunction = (state) => {
            return this.vector.getConnectedValue(state).x;
        };
        this.y._storedFunction = (state) => {
            return this.vector.getConnectedValue(state).y;
        };
        this.z._storedFunction = (state) => {
            return this.vector.getConnectedValue(state).z;
        };

        return this;
    }
}

RegisterClass("MELS.RewardSplitVectorBlock", RewardSplitVectorBlock);
